export default __webpack_public_path__ + "static/media/day3_winners.f445973d.jpg";